import { render, staticRenderFns } from "./painel-divergencias.vue?vue&type=template&id=124364ec&scoped=true&"
import script from "./painel-divergencias.vue?vue&type=script&lang=js&"
export * from "./painel-divergencias.vue?vue&type=script&lang=js&"
import style0 from "./painel-divergencias.vue?vue&type=style&index=0&id=124364ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124364ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124364ec')) {
      api.createRecord('124364ec', component.options)
    } else {
      api.reload('124364ec', component.options)
    }
    module.hot.accept("./painel-divergencias.vue?vue&type=template&id=124364ec&scoped=true&", function () {
      api.rerender('124364ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-divergencias/painel-divergencias.vue"
export default component.exports